import { FC, useState } from 'react';
import { FONT_COLOURS } from '@belong/themes';
import { ITestable } from '@belong/types';
import { Copy } from '../../styles/Typography';
import { ITextInput } from '../TextInput';
import { Password, VisibilityToggleWrapper, Wrapper } from './PasswordInput.styles';

export const TEST_ID = {
  VISIBILITY_TOGGLE: 'visibility-toggle'
};

export interface IPasswordInput extends ITextInput, ITestable {
  setFieldValue?: (newValue: string) => void;
  showLabel: string;
  hideLabel: string;
}

/**
 * The PasswordInput is a TextField which allows the user to show/hide the input, by default it is hidden
 */
export const PasswordInput: FC<IPasswordInput> = inputProps => {
  const [isVisible, setIsVisible] = useState(false);
  const visibilityLabel = isVisible ? inputProps.hideLabel : inputProps.showLabel;

  const handleToggleVisibility = (): void => {
    setIsVisible(prev => !prev);
  };

  return (
    <Wrapper>
      <Password type={isVisible ? 'text' : 'password'} {...inputProps} />
      <VisibilityToggleWrapper
        data-testid={TEST_ID.VISIBILITY_TOGGLE}
        aria-label={`${visibilityLabel} password`}
        aria-controls={inputProps.id}
        onClick={handleToggleVisibility}
        type="button"
      >
        <Copy isBold hasColor={FONT_COLOURS.AFFORDANCE} variant="small" as="span">
          {visibilityLabel}
        </Copy>
      </VisibilityToggleWrapper>
    </Wrapper>
  );
};

PasswordInput.displayName = 'PasswordInput';
